import PublicContainerContainer from './public_container_container';

const PublicContainer = PublicContainerContainer;
export default PublicContainer;
